import { buildClassesHook } from '../../../../helpers/styles';

export const useClasses = buildClassesHook({
    modalStyle: {
        maxHeight: '90vh',
        minWidth: '400px'
    }
});
